<markant-platform-notification-banner></markant-platform-notification-banner>
<div class="dashboard-content">
  <div class="dashboard-header">
    <h2 class="dashboard-headline">
      {{ 'dashboard.cartridge.headline' | transloco }}, {{ userLabel }}!
    </h2>
    <div *ngIf="!options.draggable?.enabled" class="dashboard-action-buttons">
      <markant-button
        *ngIf="hasAddableWidgets"
        class="dashboard-action-button"
        colorScheme="secondary"
        variant="clear"
        [routerLink]="['./widget-selection']"
      >
        <markant-icon icon="m_widget-add" slot="icon-leading"></markant-icon>
        {{ 'dashboard.cartridge.addWidget' | transloco }}
      </markant-button>
      <markant-button
        *ngIf="shouldDisplayArrangeButton"
        class="dashboard-action-button"
        colorScheme="secondary"
        variant="clear"
        (click)="enableDragDrop()"
      >
        <markant-icon icon="m_widget-move" slot="icon-leading"></markant-icon>
        {{ 'dashboard.cartridge.dragDrop' | transloco }}
      </markant-button>
    </div>
    <ng-container *ngIf="options.draggable?.enabled">
      <div class="drag-drop-overlay">
        <h6 class="modal-text">
          {{ 'dashboard.cartridge.dragDropModal' | transloco }}
        </h6>
        <markant-button
          class="modal-button position-right"
          colorScheme="secondary"
          variant="clear"
          (click)="disableDragDropAndSave(visibleWidgets)"
        >
          <markant-icon icon="m_checkmark" slot="icon-leading"></markant-icon>
          {{ 'dashboard.cartridge.modalButtonSubmit' | transloco }}
        </markant-button>
      </div>
    </ng-container>
  </div>
  <markant-platform-static-widgets-dashboard
    class="static-widgets-container"
    [visibleWidgets]="visibleWidgets"
    (removeStaticWidget)="removeWidget({ id: $event })"
  ></markant-platform-static-widgets-dashboard>
  <markant-platform-info-callout
    *ngIf="!loading && !hasAvailableWidgets"
    translationKey="dashboard.cartridge.noCartridges"
  ></markant-platform-info-callout>
  <div *ngIf="!loading" class="dashboard-widget-grid">
    <gridster class="gridster" [options]="options">
      <ng-container *ngFor="let widgetItem of dashboard">
        @if (
          (widgetItem.id !== addWidgetId || hasAddableWidgets) &&
          !(widgetItem.id | stringInclude: 'guided-tour') &&
          !(widgetItem.id | stringInclude: 'admin-widget') &&
          !(widgetItem.id | stringInclude: 'service-catalog-widget') &&
          !(widgetItem.id | stringInclude: 'blocked-service-widget') &&
          !(widgetItem.id | stringInclude: 'reassign-service-role-widget')
        ) {
          <gridster-item
            #gridsterItem
            class="gridster-item"
            tabindex="0"
            [item]="widgetItem"
            (focusin)="setFocusToChild(gridsterItem)"
            (focusout)="removeFocusFromChild(gridsterItem)"
          >
            <ng-container
              *ngIf="widgetItem.id !== addWidgetId; else addWidgetItem"
            >
              <markant-platform-widget
                *ngIf="widgetItem"
                class="cartridge-widget"
                [widget]="widgetItem"
                [dragActive]="!!options.draggable?.enabled"
                (widgetRemoved)="removeWidget($event)"
              >
              </markant-platform-widget>
            </ng-container>
            <ng-template #addWidgetItem>
              <markant-platform-add-widget-widget
                [routerLink]="['./widget-selection']"
              ></markant-platform-add-widget-widget>
            </ng-template>
          </gridster-item>
        }
      </ng-container>
    </gridster>
  </div>
</div>
@if (store.isCompleteProfileDialogWidgetOpen()) {
  <markant-platform-complete-profile-dialog
    (completeProfile)="navigateToFurtherQualification()"
    (close)="closerFurtherQualification()"
  ></markant-platform-complete-profile-dialog>
}
<div *ngIf="loading" class="spinner-wrapper flex-centered">
  {{ 'general.loading' | transloco }} <br />
  <markant-spinner></markant-spinner>
</div>
